import { setToken as setFetchToken } from "@elsa-zku/lib/helpers/fetch";
import { action, atom } from 'nanostores';
import { useStore, UseStoreOptions } from "@nanostores/react";
import { getUsers, IAuthUser } from "@elsa-zku/lib/helpers/auth";
import * as ws from '@elsa-zku/lib/helpers/websockets';

const { USER_TYPE } = process.env;

export const userStore = atom<IAuthUser>(null)

export const auth = action(userStore, 'auth', (store) => {
  getUsers().then(({ current }) => {
    if (!current) return unauth();
    const { user, token } = current
    if (user.type_user !== +USER_TYPE) {
      window.location.href = '/';
      return;
    }
    setFetchToken(token);
    ws.setToken(token);
    store.set(user);
  });
});

export const unauth = () => {
  delete localStorage.token;
  window.location.href = '/auth';
}

export type UseUserOptions = UseStoreOptions<typeof userStore>;
export const useUser = (options?: UseUserOptions) => useStore(userStore, options);

export const useUserId = () => {
  const user = useStore(userStore);
  return user ? user.id : null;
}
